import { render, staticRenderFns } from "./page-header.vue?vue&type=template&id=005d7ce4&scoped=true"
import script from "./page-header.vue?vue&type=script&lang=js"
export * from "./page-header.vue?vue&type=script&lang=js"
import style0 from "./page-header.vue?vue&type=style&index=0&id=005d7ce4&prod&lang=scss&scoped=true"
import style1 from "./page-header.vue?vue&type=style&index=1&id=005d7ce4&prod&lang=scss"
import style2 from "./page-header.vue?vue&type=style&index=2&id=005d7ce4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005d7ce4",
  null
  
)

export default component.exports